var Processor = require('./processor');

exports.Processor = Processor;



//////////////////
// WEBPACK FOOTER
// ./~/pixelworks/lib/index.js
// module id = tEVf
// module chunks = 0